<svelte:head>

    <title>Register • keyosh</title>

</svelte:head>

<script>
    import Register from "../../components/onboarding/register.svelte"
</script>


<section>

    <Register />

</section>


<style>

    section {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: inherit;
    }

    @media screen and (max-width: 1024px) {

        section {
            flex-direction: column;
        }

    }

</style>
